import React, { useCallback, useMemo } from "react";
import { getShouldShow } from "~/components/acquisition-popup-container/display/helpers";
import { useSdkContext } from "~/components/contexts";
import { AcquisitionNewsletterPopup } from ".";
export const useAcquisitionNewsletterPopupGetter = options => {
  const {
    acquisition: {
      popupState
    },
    userCountry,
    userTypeIds
  } = useSdkContext();
  const getNextFromConfig = useCallback(handleClose => {
    var _content$timeout;
    const content = Object.values(popupState.acquisitions).find(acquisition => getShouldShow({
      config: acquisition,
      userInfo: {
        isLoggedIn: options.isLoggedIn,
        userCountry: userCountry !== null && userCountry !== void 0 ? userCountry : "",
        userTypeIds
      }
    }));
    if (!content) return;
    const props = {
      acquisition: content,
      modalContainerReference: options.modalContainerReference,
      onClose: handleClose
    };
    return {
      delay: Number.parseInt((_content$timeout = content.timeout) !== null && _content$timeout !== void 0 ? _content$timeout : "0", 10),
      element: /*#__PURE__*/React.createElement(AcquisitionNewsletterPopup, props),
      localStorageKey: content.localStorageKey,
      updateLocalStorageOnShow: true
    };
  }, [options.isLoggedIn, options.modalContainerReference, popupState.acquisitions, userCountry, userTypeIds]);
  const getters = useMemo(() => ({
    getNextFromConfig
  }), [getNextFromConfig]);
  return getters;
};